"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.anonymizedPiiContextProvider = void 0;
const context_generators_1 = require("./context-generators");
function anonymizedPiiContextProvider(dataProvider) {
    return [
        (0, context_generators_1.anonymizedPiiContextFilter)(dataProvider),
        (0, context_generators_1.anonymizedPiiContextGenerator)(dataProvider),
    ];
}
exports.anonymizedPiiContextProvider = anonymizedPiiContextProvider;
//# sourceMappingURL=context-provider.js.map